import { Link } from 'react-router-dom';
import './Button.css';

export default function Button({
  as = 'button',
  to,
  type = 'button',
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  children,
  ...rest
}) {

  const classes = [
    'shared-btn',
    `shared-btn--${variant}`,
    `shared-btn--${size}`,
    fullWidth ? 'shared-btn--full-width' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (as === 'link') {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}
